import { ArrayType } from '../../../model/types';

import styles from './styles.module.scss';

type Props = {
  selectedOption: any;
  data: ArrayType;
  handleSelect: (event: any) => void;
  extraStyle?: React.CSSProperties;
};

const Radio = ({
  data,
  handleSelect,
  selectedOption,
  extraStyle = {},
}: Props) => {
  return (
    <div
      className={styles.radioGroup}
      style={{
        ...(extraStyle && extraStyle),
      }}
    >
      {data.map((radioItem) => (
        <label
          key={radioItem.value}
          className={selectedOption === radioItem.value ? styles.selected : ''}
        >
          <input
            type="radio"
            value={radioItem.value}
            checked={selectedOption === radioItem.value}
            onChange={handleSelect}
          />
          <div className={styles.cardContent}>{radioItem.cardContent}</div>
        </label>
      ))}
    </div>
  );
};

export default Radio;
